import { PaginationProps } from '@arco-design/web-react';
import { parseAsInteger } from 'nuqs';

export const defaultPagination: PaginationProps = {
  sizeCanChange: true,
  showTotal: true,
  pageSizeChangeResetCurrent: true,
  sizeOptions: [10, 20, 50, 100],
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
};

/**
 * 默认分页查询参数
 * @description
 * - 存储在 url 查询字符串里面 ?page=1&pageSize=10
 * - 用于初始化分页查询的默认参数, 使用 useQueryStates 进行管理
 * - 关于扩展: 可以在此基础上进行自定义扩展
 * @example
 * const [pagination, setPagination] = useQueryStates(defaultPageQuery);
 */
export const defaultPageQuery = {
  page: parseAsInteger.withDefault(1),
  pageSize: parseAsInteger.withDefault(10),
};
